import React, {useCallback, useEffect, useRef, useState} from 'react';
import { FullscreenControl, GeolocationControl, Map, Placemark, RouteButton, YMaps } from '@pbe/react-yandex-maps';
import {
    BackgroundContainer, CAddress, CContainer, CItem, CList, CMap, CName,
    GraveAddress,
    GraveDivider,
    Graveyard,
    GraveyardName,
} from './styles';

const x = 68.963873;
const y = 33.079328;
const phone1 = ['+78152784454', '+7 (815) 278-44-54'];
const phone2 = ['+79211743454', '+7 (921) 174-34-54'];

const AboutUsPage = () => {
    const ref: any = useRef();
    const ref2: any = useRef();
    const ymaps: any = React.useRef(null);

  const mapState = {
    center: [x, y],
    zoom: 15,
    controls: []
  };
    const onYmapsLoad = (e: any) => {
        ymaps.current = e;
    }

  return (
    <>
        <BackgroundContainer style={{marginTop: '120px', paddingTop: '20px', paddingBottom: '20px'}}>
          <Graveyard>
            <GraveyardName>ООО &quot;Северснаб Групп&quot;</GraveyardName>
            <GraveDivider />
            <GraveAddress>
                <p> <b>Адрес:</b> г. Мурманск, Улица Капитана Буркова, 21 (Вход со стороны дороги) </p>
                <p><b>Номера телефона:</b></p>
                <p><a href={`tel:${phone1[0]}`}>{phone1[1]}</a></p>
                <p><a href={`tel:${phone2[0]}`}>{phone2[1]}</a></p>
            </GraveAddress>
          </Graveyard>
            <CContainer>
                <CMap>
                    <Map state={{
                        ...mapState,
                        center: [x, y],
                    }} width="100%" height="440px" onLoad={onYmapsLoad} instanceRef={ref2}>
                        <Placemark modules={["geoObject.addon.balloon"]} geometry={[x, y]} properties={
                            {
                                balloonContentBody: `<p>г. Мурманск, Улица Капитана Буркова, 21 (Вход со стороны дороги)</p>`,
                            }
                        } instanceRef={ref}/>
                        <FullscreenControl />
                        <GeolocationControl />
                        <RouteButton />
                    </Map>
                </CMap>
            </CContainer>
        </BackgroundContainer>
    </>
  );
}

export default AboutUsPage;